import React from "react";
import AccountActivationForm from "../components/account-activation/AccountActivationForm";
export default function AccountActivation() {
  return <AccountActivationForm />;
}
